import ModalBase from 'LuxKit/Modal/ModalBase'
import React, { useReducer } from 'react'
import BusinessTravellerNewPersonalUserSetupStep from './steps/BusinessTravellerNewPersonalUserSetupStep'
import BusinessTravellerExistingPersonalUserSetupStep from './steps/BusinessTravellerExistingPersonalUserSetupStep'
import BusinessTravellerPersonalEmailUpdateSetupStep from './steps/BusinessTravellerPersonalEmailUpdateSetupStep'
import BusinessTravellerPersonalAccountLinkConfirmationSetupStep from './steps/BusinessTravellerPersonalAccountLinkConfirmationSetupStep'
import { BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS, BusinessTravellerPersonalAccountLinkingDispatchContext, BusinessTravellerPersonalAccountLinkingStateContext, businessTravellerPersonalAccountLinkingStateReducer } from 'businessTraveller/contexts/BusinessTravellerPersonalAccountLinkingContexts'

interface Props {
  business: App.BusinessTraveller.Business
  employee: App.BusinessTraveller.Employee
}

function BusinessTravellerPersonalAccountLinkingModal(props: Props) {
  const { business, employee } = props
  const [accountLinkingState, accountLinkingDispatch] =
    useReducer(businessTravellerPersonalAccountLinkingStateReducer, {
      businessDetails: {
        id: business?.id,
        name: business?.name,
      },
      employeeProfile: {
        id: employee?.id,
        email: employee?.email,
        firstName: employee?.firstName,
        lastName: employee?.lastName,
      },
      personalEmail: '',
      step: BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.PERSONAL_EMAIL_UPDATE,
    })
  const { step } = accountLinkingState!

  return <ModalBase size="S">
    <BusinessTravellerPersonalAccountLinkingStateContext.Provider value={accountLinkingState!}>
      <BusinessTravellerPersonalAccountLinkingDispatchContext.Provider value={accountLinkingDispatch}>
        {step === BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.PERSONAL_EMAIL_UPDATE &&
          <BusinessTravellerPersonalEmailUpdateSetupStep />}

        {step === BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.NEW_PERSONAL_USER &&
          <BusinessTravellerNewPersonalUserSetupStep />}

        {step === BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.EXISTING_PERSONAL_USER &&
          <BusinessTravellerExistingPersonalUserSetupStep />}

        {step === BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.PERSONAL_ACCOUNT_LINK_CONFIRMATION &&
          <BusinessTravellerPersonalAccountLinkConfirmationSetupStep />}

      </BusinessTravellerPersonalAccountLinkingDispatchContext.Provider>
    </BusinessTravellerPersonalAccountLinkingStateContext.Provider>
  </ModalBase>
}

export default BusinessTravellerPersonalAccountLinkingModal
